const url = 'https://kind-pink-anemone-tutu.cyclic.app/getDetails/'

function getProuduct(id, setData, setError, setLoading, setDesc) {
    fetch(`${url}${id}`).then(response => {
        if (response.ok) {
            return response.json()
        }
        throw response
    }).then(data => {
        setData(data.productData)
        const desc = data.productData.description.split(":")
        setDesc(desc)
    }).catch(error => {
        setError(error)
    }).finally(() => {
        setLoading(false)
    })
}

export default getProuduct